import React, { useState, useMemo } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography,
  TextField, IconButton, Divider, Chip,
} from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { SOLES_DENOMINATIONS } from '../../types/cash';

const money = (n: number) => `S/ ${n.toFixed(2)}`;

interface Props {
  open: boolean;
  onClose: () => void;
  onApply: (total: number) => void;
}

// Calculadora de arqueo: cuenta billetes/monedas y devuelve el total contado.
const DenominationCalculator: React.FC<Props> = ({ open, onClose, onApply }) => {
  const [qty, setQty] = useState<Record<number, number>>({});

  const total = useMemo(
    () => SOLES_DENOMINATIONS.reduce((sum, d) => sum + d.value * (qty[d.value] || 0), 0),
    [qty],
  );

  const setVal = (value: number, n: number) =>
    setQty((p) => ({ ...p, [value]: Math.max(0, n) }));

  const handleApply = () => {
    onApply(Math.round(total * 100) / 100);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Conteo de efectivo</DialogTitle>
      <DialogContent dividers>
        {SOLES_DENOMINATIONS.map((d) => {
          const n = qty[d.value] || 0;
          return (
            <Box key={d.value} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Chip label={d.kind === 'billete' ? 'B' : 'M'} size="small" sx={{ width: 26 }} />
              <Typography sx={{ width: 70, fontWeight: 600 }}>{d.label}</Typography>
              <IconButton size="small" onClick={() => setVal(d.value, n - 1)}><Remove fontSize="small" /></IconButton>
              <TextField
                size="small" type="number" value={n}
                onChange={(e) => setVal(d.value, parseInt(e.target.value) || 0)}
                sx={{ width: 70 }} inputProps={{ style: { textAlign: 'center' }, min: 0 }}
              />
              <IconButton size="small" onClick={() => setVal(d.value, n + 1)}><Add fontSize="small" /></IconButton>
              <Box sx={{ flexGrow: 1 }} />
              <Typography sx={{ width: 80, textAlign: 'right', color: '#6B7280' }}>{money(d.value * n)}</Typography>
            </Box>
          );
        })}
        <Divider sx={{ my: 1 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: 20 }}>
          <span>Total contado</span><span>{money(total)}</span>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={() => setQty({})}>Limpiar</Button>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleApply}>Usar total</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DenominationCalculator;
